import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';
import { ProfileComponent } from './profile.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { IntroComponent } from './intro/intro.component';
import { AboutComponent } from './about/about.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ContactComponent } from './contact/contact.component';
import { DifficultiesComponent } from './difficulties/difficulties.component';
import { TherapieComponent } from './therapie/therapie.component';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from "@angular/router";
import {TabComponent} from "../tab/tab.component";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SnotifyModule,
        FormsModule,
        ReactiveFormsModule,
        NgxSpinnerModule,
        RouterModule
    ],
    declarations: [
        ProfileComponent,
        HeaderComponent,
        FooterComponent,
        AboutComponent,
        IntroComponent,
        ContactComponent,
        DifficultiesComponent,
        AboutComponent,
        TherapieComponent,
        TabComponent,
    ],
  providers: [
    { provide: 'SnotifyToastConfig', useValue: ToastDefaults},
    SnotifyService,
  ]
})
export class ProfileModule { }
